import { render, staticRenderFns } from "./PostSetting.vue?vue&type=template&id=31312bd4&scoped=true&"
import script from "./PostSetting.vue?vue&type=script&lang=js&"
export * from "./PostSetting.vue?vue&type=script&lang=js&"
import style0 from "./PostSetting.vue?vue&type=style&index=0&id=31312bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31312bd4",
  null
  
)

export default component.exports